/**
 * @generated SignedSource<<c46394a13fa578023c2ef6d8e4c38f5f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type PricingVersion = "VERSION_1" | "VERSION_2";
export type previewQuery$variables = Record<PropertyKey, never>;
export type previewQuery$data = {
  readonly salesChannels: ReadonlyArray<{
    readonly ecommerceSettings: {
      readonly ecommerceName: ECommerce;
    } | null;
  }>;
  readonly subscription: {
    readonly maxProducts: {
      readonly maxProducts: number | null;
      readonly numProducts: number | null;
      readonly numPublishedProducts: number | null;
      readonly pricingVersion: PricingVersion;
    };
  } | null;
};
export type previewQuery = {
  response: previewQuery$data;
  variables: previewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "MaxProducts",
  "kind": "LinkedField",
  "name": "maxProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numPublishedProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxProducts",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "previewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "previewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      }
    ]
  },
  "params": {
    "cacheID": "4607ab7b14481fa93b1ab7b3af69945e",
    "id": null,
    "metadata": {},
    "name": "previewQuery",
    "operationKind": "query",
    "text": "query previewQuery {\n  subscription {\n    maxProducts {\n      pricingVersion\n      numProducts\n      numPublishedProducts\n      maxProducts\n    }\n    id\n  }\n  salesChannels(status: ACTIVE) {\n    ecommerceSettings {\n      ecommerceName\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "78a07ab34434de6ceb91e259e5faae7e";

export default node;
